// Authoritative category/subcategory taxonomy from GET /common/service-categories,
// fetched once per entityType on first app load (see layout/index.vue's created()).
// Shape per entry: {key, displayName, subCategories:[{key, displayName}]}.
import { getServiceCategories } from "@/api/information.js";

export default {
  namespaced: true,
  state: {
    hotel: [],
    restaurant: [],
  },
  mutations: {
    SET_HOTEL_CATEGORIES(state, list) {
      state.hotel = Array.isArray(list) ? list : [];
    },
    SET_RESTAURANT_CATEGORIES(state, list) {
      state.restaurant = Array.isArray(list) ? list : [];
    },
  },
  actions: {
    // Skips the request if this entityType's list is already loaded.
    async fetchServiceCategories({ commit, state }, entityType) {
      const isHotel = entityType === "Hotel";
      if (isHotel && state.hotel.length) return state.hotel;
      if (!isHotel && state.restaurant.length) return state.restaurant;
      try {
        const res = await getServiceCategories(entityType);
        const list = Array.isArray(res) ? res : [];
        commit(isHotel ? "SET_HOTEL_CATEGORIES" : "SET_RESTAURANT_CATEGORIES", list);
        return list;
      } catch (e) {
        console.error("common/service-categories error:", e);
        return [];
      }
    },
  },
};
